/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Filters_Searchplaceholder2Inputs */

const en_settings_casmanagement_filters_searchplaceholder2 = /** @type {(inputs: Settings_Casmanagement_Filters_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search funds`)
};

/**
* | output |
* | --- |
* | "Search funds" |
*
* @param {Settings_Casmanagement_Filters_Searchplaceholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_filters_searchplaceholder2 = /** @type {((inputs?: Settings_Casmanagement_Filters_Searchplaceholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Filters_Searchplaceholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_filters_searchplaceholder2(inputs)
});
export { settings_casmanagement_filters_searchplaceholder2 as "settings_casManagement_filters_searchPlaceholder" }